'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paginator = exports.SET_PAGE = exports.SET_PAGE_COUNT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _atpPointfree = require('atp-pointfree');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//Action type definitions
var SET_PAGE_COUNT = exports.SET_PAGE_COUNT = 'basic/paginator/setCount';
var SET_PAGE = exports.SET_PAGE = 'basic/paginator/setPage';

//Action creators and selectors
var paginator = exports.paginator = {
    setPageCount: function setPageCount(name, count) {
        return { type: SET_PAGE_COUNT, name: name, count: count };
    },
    setPage: function setPage(name, page) {
        return { type: SET_PAGE, name: name, page: page };
    },
    get: function get(getState, name) {
        return getPaginatorData(getState().basic.paginator, name);
    }
};

var getPaginatorData = function getPaginatorData(state, name) {
    return typeof state[name] !== 'undefined' ? state[name] : { page: 1, pages: 1 };
};

//Reducer

exports.default = function () {
    var _switchOn;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return (0, _atpPointfree.switchOn)(action.type, (_switchOn = {}, _defineProperty(_switchOn, SET_PAGE_COUNT, function () {
        return _extends({}, state, _defineProperty({}, action.name, _extends({}, getPaginatorData(state, action.name), {
            pages: action.count
        })));
    }), _defineProperty(_switchOn, SET_PAGE, function () {
        return _extends({}, state, _defineProperty({}, action.name, _extends({}, getPaginatorData(state, action.name), {
            page: action.page
        })));
    }), _defineProperty(_switchOn, 'default', function _default() {
        return state;
    }), _switchOn));
};